import { Link } from "@mui/material";

export const LiveNationRegistrationTerms = () => (
  <>
    By creating an account you agree to receive notifications regarding your
    purchase and Live Nation offers as well as the{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms & Conditions
    </Link>
    ,{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>{" "}
    and Premium Seat Program{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://premium.livenation.com/seat-terms"
    >
      Terms & Conditions
    </Link>
    .
  </>
);

export const LiveNationCheckoutTerms = () => (
  <>
    By purchasing you agree to receive notifications regarding ticket delivery
    and agree to the{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms & Conditions
    </Link>
    ,{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>{" "}
    and the Live Nation Premium Seat Program{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://premium.livenation.com/seat-terms"
    >
      Terms & Conditions
    </Link>
    .
  </>
);

export const LiveNationCheckoutTermsV2 = () => (
  <>
    By purchasing you agree to receive notifications regarding ticket delivery
    and agree to the{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms & Conditions
    </Link>
    ,{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>{" "}
    and the Live Nation Premium Seat Program{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://premium.livenation.com/seat-terms"
    >
      Terms & Conditions
    </Link>
    .
    <br />
    <br />
    <b>
      <u>Please Note</u>: Some seating options may be shared spaces. If the
      seats you select do not make up an entire box or suite, the remaining
      seats may be sold to other parties. This will be more likely when
      purchasing seats in pairs.
    </b>
  </>
);

export const LiveNationAdditionalDetailsDisclaimerTC = () => (
  <>
    By entering my name, checking the box above and clicking Checkout, I hereby
    (i) agree to the{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>{" "}
    (ii) agree that my reservation will not be complete unless and until I
    receive a notice from Live Nation confirming whether or not my reservation
    has been accepted in accordance with our agreement.
  </>
);
